import UIComponent from "../../common/UIComponent";
import "./index.css";
export default class SpeedBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.init();
  }

  init() {
    this.speedComponent = document.createElement("div");
    this.speedComponent.setAttribute("class", "vhallPlayer-speed-component");
    this.speedComponent.onmouseleave = this.handleComponentMouseLeave.bind(this);

    this.speedBtn = document.createElement("span");
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn");
    this.speedBtn.innerText = "倍速";
    this.speedBtn.onclick = this.handleBtnClick.bind(this);


    this.speedListPopup = document.createElement("div");
    this.speedListPopup.setAttribute("class", "speed-popup");

    this.speedListBox = document.createElement("ul");
    this.speedListBox.setAttribute("class", "speed-list-box");
    this.interfaces.getUsableSpeed().forEach((value, index) => {
      this.speedItem = document.createElement("li");
      this.speedItem.onclick = this.handleItemClick.bind(this);
      this.speedItem.innerText = value;
      this.speedListBox.appendChild(this.speedItem);
    });
    this.speedListPopup.appendChild(this.speedListBox);

    this.speedComponent.appendChild(this.speedBtn);
    this.speedComponent.appendChild(this.speedListPopup);
    this.appendChild(this.elementId, this.speedComponent);
  }


  handleComponentMouseLeave() {
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn")
    this.speedListPopup.style.display = "none";
    this.speedListPopup.style.opacity = "0";
  }

  handleBtnClick() {
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn active")
    this.speedListPopup.style.display = "block";
    this.speedListPopup.style.opacity = "1";
  }

  handleItemClick(event) {
    const value = event.target.innerText;
    if (value === "1") {
      this.speedBtn.innerText = "倍速";
    } else {
      this.speedBtn.innerText = value;
    }
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn")
    this.speedListPopup.style.display = "none";
    this.speedListPopup.style.opacity = "0";
    this.interfaces.setPlaySpeed(Number(value));
  }
}